import React from "react";
import "./Welton.scss";
import data from "./data.json";
import Card from "../../../Component/Card/card";
import Welton7images from "../../../Media/BSD/Hiera/Welton7";
import Welton8images from "../../../Media/BSD/Hiera/Welton8";
import Welton9images from "../../../Media/BSD/Hiera/Welton9";

const imageMap = {
  Welton7images,
  Welton8images,
  Welton9images,
  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="Welton" className="produk">
      <h1>Welcome to Welton</h1>
      <h2>Cicilan Start 13 Juta/Bulan</h2>
      <div className="cardhome-containerf">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
